import React, { Fragment } from 'react';
import { withLocalize } from 'react-localize-redux';
import { compose } from 'recompose';

import VideoUploader from '../../uploader/VideoModal';
import ErrorMessage from './errorMessage';


const defaultTrigger = props => <button type='button'>{props.translate('upload.file')}</button>;

const getOptions = type => {
  switch (type) {
    case 'video': {
      return {
        accept: '.mp4'
      };
    }
    default:
      return {};
  }
};

const HHVideoUploader = ({
  field,
  form: { touched, errors, setFieldValue },
  otherProps: {
    trigger, type, onUpload, eventSlug
  },
  getPreviewLink
}) => {
  const hasError = !!(touched[field.name] && errors[field.name]);

  return (
    <Fragment>
      <VideoUploader
        onChange={(res, key) => {
            setFieldValue('fileKey', key);
            setFieldValue('uploadedVideoUrl', '');
            setFieldValue(field.name, '');
          if (typeof onUpload === 'function') onUpload(res);
          getPreviewLink(key);
          }}
        trigger={trigger || defaultTrigger}
        {...getOptions(type)}
        eventSlug={eventSlug}
      />
      {hasError && (<ErrorMessage error={errors[field.name]} />)}
    </Fragment>
  );
};

export default compose(withLocalize)(HHVideoUploader);



// WEBPACK FOOTER //
// ./src/components/forms/fields/hhVideoUploader.js